import { render, staticRenderFns } from "./ReporteEstadoPptoEgresosCurrencyRow.vue?vue&type=template&id=fa4b2f22&scoped=true&"
import script from "./ReporteEstadoPptoEgresosCurrencyRow.vue?vue&type=script&lang=js&"
export * from "./ReporteEstadoPptoEgresosCurrencyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4b2f22",
  null
  
)

export default component.exports